module.exports = __webpack_public_path__ + "img/activity-share-guide.6bd775ca.png";